import { eachDayOfInterval, endOfMonth, startOfMonth } from "date-fns";

export const findSelectableDate = (
  month: Date,
  referenceDate: Date,
  disabledDate?: (date: Date) => boolean
) => {
  const days = eachDayOfInterval({
    end: endOfMonth(month),
    start: startOfMonth(month),
  });
  const isSelectable = (date: Date) => !disabledDate?.(date);
  const sameDayOfMonth = days.find((day) => day.getDate() === referenceDate.getDate());

  if (sameDayOfMonth && isSelectable(sameDayOfMonth)) {
    return sameDayOfMonth;
  }

  return days.find(isSelectable);
};
